export const PERFORMER_PROFILE_PATH = "/profile";
export const EDIT_PROFILE_ROUTE = "details";
export const CONTACTS_ROUTE = "contacts";
